import { axiosInstance } from "./index";
import { ApiResponse, ApiRequest } from "./types";

import { reportsMock } from "./mocks/reports";
import { getReportMock } from "./mocks/report";

// FIXME zendesk.tsに処理を移動させる
export const getZendeskJwt = async () => {
  const response = await axiosInstance.get<ApiResponse.ZendeskJwt>(
    `/api/cloud/recruitment_planning/v1/payload`
  );
  return response;
};

export const getPartnerUser = async () => {
  const response = await axiosInstance.get<ApiResponse.GetPartnerUserWithAdmin>(
    `/api/cloud/recruitment_planning/v1/partner_user`
  );
  // NOTE: オンボーディング表示
  // return insertMockDataToResponse(response, {
  //   onboarding_finished: false,
  //   partner: {
  //     ...response.data.partner,
  //     recruitment_number_registered: false
  //   }
  // });
  return response;
};

export const signIn = async (params: ApiRequest.SignIn) => {
  const data = new FormData();
  data.append("partner_user[email]", params.email);
  data.append("partner_user[password]", params.password);

  const response = await axiosInstance.post<ApiResponse.SignIn>(
    `/api/cloud/recruitment_planning/v1/partner_users/sign_in`,
    data,
    {
      headers: {
        "content-type": "multipart/form-data"
      }
    }
  );
  // NOTE: オンボーディング表示
  // return insertMockDataToResponse(response, {
  //   partner_user: {
  //     onboarding_finished: false,
  //     partner: {
  //       ...response.data.partner_user.partner,
  //       recruitment_number_registered: false
  //     }
  //   }
  // });
  return response;
};

export const signInToken = async (params: ApiRequest.SignInToken) => {
  const data = new FormData();
  data.append("partner_user[oc_token]", params.partner_user.oc_token);

  const response = await axiosInstance.put<ApiResponse.SignIn>(
    `/api/cloud/recruitment_planning/v1/partner_users/sign_in`,
    data,
    {
      headers: {
        "content-type": "multipart/form-data"
      }
    }
  );
  return response;
};

export const signOut = async () => {
  const result = await axiosInstance.delete<ApiResponse.SignOut>(
    `/api/cloud/recruitment_planning/v1/partner_users/sign_out`
  );
  return result;
};

export const passwordReissue = async (params: ApiRequest.PasswordReissue) => {
  const response = await axiosInstance.post<ApiResponse.PasswordReissue>(
    `/api/cloud/recruitment_planning/v1/password`,
    {
      partner_user: params
    }
  );
  return response;
};

export const passwordReset = async (params: ApiRequest.PasswordReset) => {
  const response = await axiosInstance.put<ApiResponse.PasswordReset>(
    `/api/cloud/recruitment_planning/v1/password`,
    {
      partner_user: params
    }
  );
  return response;
};

export const getAvailableGraduateYears = async () => {
  const response = await axiosInstance.get<ApiResponse.AvailableGraduateYears>(
    `/api/cloud/recruitment_planning/v1/available_graduate_years`
  );
  return response;
};

export const createPlan = async (params: ApiRequest.CreatePlan) => {
  const response = await axiosInstance.post<ApiResponse.Plan>(
    `/api/cloud/recruitment_planning/v1/partners/${params.partnerId}/plans`,
    {
      name: params.name,
      graduate_year: params.graduateYear
    }
  );
  return response;
};

export const duplicatePlan = async (params: ApiRequest.DuplicatePlan) => {
  const response = await axiosInstance.post<ApiResponse.Plan>(
    `/api/cloud/recruitment_planning/v1/partners/${params.partnerId}/plans/clone`,
    {
      id: params.planId,
      name: params.name,
      graduate_year: params.graduateYear
    }
  );
  return response;
};

export const updatePlan = async (params: ApiRequest.UpdatePlan) => {
  const response = await axiosInstance.patch<ApiResponse.PlanUpdate>(
    `/api/cloud/recruitment_planning/v1/partners/${params.partnerId}/plans/${params.planId}`,
    {
      name: params.name
    }
  );
  return response;
};

export const deletePlan = async (params: ApiRequest.DeletePlan) => {
  const response = await axiosInstance.delete(
    `/api/cloud/recruitment_planning/v1/partners/${params.partnerId}/plans/${params.planId}`
  );
  return response;
};

export const createEvent = async (params: ApiRequest.CreateEvent) => {
  const response = await axiosInstance.post<ApiResponse.EventCreate>(
    `/api/cloud/recruitment_planning/v1/partners/${params.partner_id}/plans/${params.plan_id}/recruitment_events`,
    {
      name: params.recruitmentEvent.name,
      event_type: params.recruitmentEvent.event_type,
      start_at: params.recruitmentEvent.start_at,
      end_at: params.recruitmentEvent.end_at,
      description: params.recruitmentEvent.description,
      reference_url: params.recruitmentEvent.reference_url
    }
  );
  return response;
};

export const updateEvent = async (params: ApiRequest.UpdateEvent) => {
  const response = await axiosInstance.patch<ApiResponse.EventUpdate>(
    `/api/cloud/recruitment_planning/v1/partners/${params.partner_id}/plans/${params.plan_id}/recruitment_events/${params.recruitment_event_id}`,
    {
      name: params.recruitmentEvent.name,
      event_type: params.recruitmentEvent.event_type,
      start_at: params.recruitmentEvent.start_at,
      end_at: params.recruitmentEvent.end_at,
      description: params.recruitmentEvent.description,
      reference_url: params.recruitmentEvent.reference_url
    }
  );
  return response;
};

export const deleteEvent = async (params: ApiRequest.DeleteEvent) => {
  const response = await axiosInstance.delete<ApiResponse.EventDelete>(
    `/api/cloud/recruitment_planning/v1/partners/${params.partner_id}/plans/${params.plan_id}/recruitment_events/${params.recruitment_event_id}`
  );
  return response;
};

export const getPlans = async (params: ApiRequest.GetPlans) => {
  const response = await axiosInstance.get<ApiResponse.Plan[]>(
    `api/cloud/recruitment_planning/v1/partners/${params.partnerId}/plans`
  );

  return response;
};

export const getPlan = async (params: ApiRequest.GetPlan) => {
  const response = await axiosInstance.get<ApiResponse.PlanDetail>(
    `api/cloud/recruitment_planning/v1/partners/${params.partner_id}/plans/${params.plan_id}`
  );

  return response;
};

export const getNewExperiences = async () => {
  const response = await axiosInstance.get<{
    new_experiences: ApiResponse.NewExperience[];
  }>("/api/recruitment_planning/v1/home/new_experiences");
  return {
    ...response,
    data: {
      ...response.data,
      new_experiences: response.data.new_experiences || []
    }
  };
};

export const getCompanies = async (params: ApiRequest.GetCompaniesExplorer) => {
  const response = await axiosInstance.get<ApiResponse.CompaniesExplorer>(
    "/api/recruitment_planning/v1/companies/explorer",
    {
      params
    }
  );
  return response;
};

export const getCompaniesExplorerRank = async (
  params: ApiRequest.GetCompaniesExplorerRank
) => {
  const response = await axiosInstance.get<ApiResponse.CompaniesExplorer>(
    "/api/recruitment_planning/v1/companies/explorer/rankings",
    {
      params
    }
  );
  return response;
};

export const getCompanyDetail = async (params: ApiRequest.GetCompanyDetail) => {
  const response = await axiosInstance.get<ApiResponse.CompanyDetail>(
    `api/recruitment_planning/v1/companies/explorer/${params.company_id}`
  );
  return response;
};

export const getCompanyDetailV2 = async (
  params: ApiRequest.GetCompanyDetail
) => {
  const response = await axiosInstance.get<ApiResponse.CompanyDetailV2>(
    `api/recruitment_planning/v1.1/companies/explorer/${params.company_id}`
  );
  return response;
};
export const getBusinessCategoriesAverages = async (
  params: ApiRequest.GetBusinessCategoriesAverages
) => {
  const response = await axiosInstance.get<
    ApiResponse.BusinessCategoriesAverages
  >(
    `/api/recruitment_planning/v1/business_categories/${params.business_category_id}/averages`
  );
  return response;
};

export const getReviewGraph = async (params: ApiRequest.GetReviewGraph) => {
  const response = await axiosInstance.get<ApiResponse.ReviewGraph>(
    `/api/recruitment_planning/v1/companies/explorer/${params.company_id}/review_graph`,
    {
      params: { category: params.category }
    }
  );
  return response;
};

export const getFavoriteGraph = async (params: ApiRequest.GetFavoriteGraph) => {
  const response = await axiosInstance.get<ApiResponse.FavoriteGraph>(
    `api/recruitment_planning/v1/companies/explorer/${params.company_id}/favorite_graph`
  );
  return response;
};

export const getCompanyDetailRatings = async (
  params: ApiRequest.GetCompanyDetailRatings
) => {
  const response = await axiosInstance.get<ApiResponse.CompanyDetailRatings>(
    `api/recruitment_planning/v1/companies/explorer/${params.company_id}/ratings`,
    {
      params:
        params["rating_title"] !== "rating_ave"
          ? {
              category: params.category,
              rating_title: params.rating_title
            }
          : {
              category: params.category
            }
    }
  );
  return response;
};

export const getCompanyDetailReviews = async (
  params: ApiRequest.GetCompanyDetailReviews
) => {
  const { company_id, ...queryParams } = params;
  const response = await axiosInstance.get<{
    reviews: ApiResponse.CompanyDetailReviewData[];
  }>(`api/recruitment_planning/v1/companies/explorer/${company_id}/reviews`, {
    params: queryParams
  });
  return response;
};

export const getCompanyList = async (params: ApiRequest.GetCompanyList) => {
  const response = await axiosInstance.get<ApiResponse.Companies>(
    `/api/recruitment_planning/v1/plans/${params.plan_id}/companies`,
    {
      params: {
        company_name: params.company_name,
        limit: params.limit,
        offset: params.offset,
        business_category_id: params.business_category_id,
        sort: params.sort
      }
    }
  );
  return response;
};

export const getUniversities = async (params: ApiRequest.GetUniversities) => {
  const response = await axiosInstance.get<ApiResponse.CompactUniversities>(
    "/api/cloud/recruitment_planning/v1/universities",
    { params }
  );
  return response;
};

export const getUniversityList = async (
  params: ApiRequest.GetUniversityList
) => {
  const response = await axiosInstance.get<ApiResponse.Universities>(
    `/api/cloud/recruitment_planning/v1/university_events/${params.graduateYear}?name=${params.universityName}&course=${params.universityCourse}`
  );
  return response;
};

export const getCompetitorEmbedded = async (
  params: ApiRequest.GetCompetitorEmbedded
) => {
  const response = await axiosInstance.get<ApiResponse.CompetitorEmbedded>(
    `/api/cloud/recruitment_planning/v1/partners/${params.partnerId}/plans/${params.planId}/competitors/${params.competitorId}`
  );
  return response;
};

export const getStudentEmbedded = async (
  params: ApiRequest.GetStudentEmbedded
) => {
  const response = await axiosInstance.get<ApiResponse.StudentEmbedded>(
    `/api/cloud/recruitment_planning/v1/partners/${params.partnerId}/plans/${params.planId}/students/${params.studentId}`
  );
  return response;
};

export const createCompetitor = async (params: ApiRequest.CreateCompetitor) => {
  const response = await axiosInstance.post<ApiResponse.Competitor>(
    `/api/recruitment_planning/v1.1/plans/${params.planId}/competitors`,
    {
      company: params.company
    }
  );
  return response;
};

export const updateCompetitor = async (params: ApiRequest.UpdateCompetitor) => {
  return await axiosInstance.put(
    `/api/cloud/recruitment_planning/v1/partners/${params.partnerId}/plans/${params.planId}/competitors/${params.competitorId}`,
    {
      company: { ...params.company }
    }
  );
};

export const deleteCompetitor = async (params: ApiRequest.DeleteCompetitor) => {
  const response = await axiosInstance.delete<ApiResponse.Competitor>(
    `/api/cloud/recruitment_planning/v1/partners/${params.partnerId}/plans/${params.planId}/competitors/${params.competitorId}`
  );
  return response;
};

export const deleteUniversity = async (params: ApiRequest.DeleteUniversity) => {
  const response = await axiosInstance.delete(
    `/api/cloud/recruitment_planning/v1/partners/${params.partnerId}/plans/${params.planId}/students/${params.studentId}`
  );
  return response;
};

export const createUniversity = async (params: ApiRequest.CreateUniversity) => {
  const response = await axiosInstance.post<ApiResponse.StudentSegment>(
    `/api/cloud/recruitment_planning/v1/partners/${params.partnerId}/plans/${params.planId}/students`,
    {
      university: { ...params.university }
    }
  );
  return response;
};

export const updateUniversity = async (params: ApiRequest.UpdateUniversity) => {
  const response = await axiosInstance.patch<ApiResponse.StudentSegment>(
    `/api/cloud/recruitment_planning/v1/partners/${params.partnerId}/plans/${params.planId}/students/${params.studentId}`,
    {
      university: { ...params.university }
    }
  );
  return response;
};

export const getStudentJobHuntingTrendCollection = async (
  params: ApiRequest.GetStudentJobHuntingTrendCollection
) => {
  const response = await axiosInstance.get<
    ApiResponse.StudentJobHuntingTrendCollection
  >(
    `/api/cloud/recruitment_planning/v1/partners/${params.partnerId}/plans/${params.planId}/student_job_hunting_trends/${params.universityId}`
  );
  return response;
};

// 未使用のためコメントアウト
// export const getEventExperiences = async (params: {
//   competitorEventIds: number[];
// }) => {
//     const competitorEventIdsQuery = createQueryFromArray(
//       "competitor_event_ids",
//       params.competitorEventIds
//     );
//     const response = await axiosInstance.get<ApiResponse.EventExperiences>(
//       `api/cloud/recruitment_planning/v1/event_experiences/` +
//         `?` +
//         competitorEventIdsQuery
//     );
//     return response;
//     // return { data: mockEventExperiencesResponse }; // Mock
// }

export const getEventExperiences = async (
  params: ApiRequest.GetEventExperiences
) => {
  const response = await axiosInstance.post<ApiResponse.EventExperiences>(
    `api/cloud/recruitment_planning/v1/event_experiences`,
    params
  );
  // NOTE API出来たら戻す
  // response.data.event_experiences = response.data.event_experiences.map(
  //   (e, i) => {
  //     return {
  //       ...e,
  //       clip_id: i % 2 ? Math.floor(Math.random() * Math.random() * 10) : 0
  //     };
  //   }
  // );
  return response;
};

export const getEventExperience = async (
  params: ApiRequest.GetEventExperience
) => {
  const response = await axiosInstance.get<ApiResponse.EventExperienceEmbedded>(
    `api/cloud/recruitment_planning/v1/event_experiences/${params.eventExperienceId}`
  );
  return response;
};

export const getEventDetail = async (params: ApiRequest.GetEventDetail) => {
  const response = await axiosInstance.get<ApiResponse.EventDetailEmbedded>(
    `api/cloud/recruitment_planning/v1/event_details/${params.eventDetailId}`
  );
  // const response = { data: getEventDetailMock };
  return response;
};
export const getReports = async (_params: ApiRequest.GetReports) => {
  // const response = await axiosInstance.get<ApiResponse.Reports>(
  //   `api/cloud/recruitment_planning/v1/plans/${params.planId}/reports`
  // );
  const response = { data: reportsMock };
  return response;
};
export const getReport = async (params: ApiRequest.GetReport) => {
  // const response = await axiosInstance.get<ApiResponse.Report>(
  //   `api/cloud/recruitment_planning/v1/plans/${params.planId}/${
  //     params.type === "MONTHLY" ? "monthly_reports" : "weekly_reports"
  //   }/${params.reportId}`
  // );
  const response = { data: getReportMock(params) };
  return response;
};
export const getNotifications = async (params: ApiRequest.GetNotifications) => {
  const response = await axiosInstance.get<ApiResponse.Notifications>(
    "/api/cloud/recruitment_planning/v1/notifications",
    { params }
  );
  return response;
};
export const readNotification = async (params: ApiRequest.ReadNotification) => {
  await axiosInstance.patch<ApiResponse.Reports>(
    `api/cloud/recruitment_planning/v1/notifications/${params.notificationId}`
  );
};
export const getNotificationSetting = async () => {
  const response = await axiosInstance.get<ApiResponse.NotificationSetting>(
    "/api/recruitment_planning/v1.1/notification_setting"
  );
  return response;
};

export const updateNotificationSetting = async (
  params: ApiRequest.UpdateNotificationSetting
) => {
  const response = await axiosInstance.post<ApiResponse.NotificationSetting>(
    "/api/recruitment_planning/v1.1/notification_setting",
    params
  );
  return response;
};

export const getClips = async () => {
  const response = await axiosInstance.get<ApiResponse.Clip[]>(
    "/api/cloud/recruitment_planning/v1/clips"
  );
  return response;
};

export const createClip = async (params: ApiRequest.CreateClip) => {
  const response = await axiosInstance.post<ApiResponse.Clip>(
    "/api/cloud/recruitment_planning/v1/clips",
    params
  );
  // const response = { data: getClipMock(params) };
  return response;
};

export const deleteClip = async (params: ApiRequest.DeleteClip) => {
  const response = await axiosInstance.delete(
    `/api/cloud/recruitment_planning/v1/clips/${params.clip_id}`
  );
  return response;
};

export const getTopUniversityFollowees = async (
  params: ApiRequest.GetTopFollowees
) => {
  const response = await axiosInstance.get<ApiResponse.TopUniversityFollowees>(
    `/api/recruitment_planning/v1/universities/top_followees`,
    {
      params
    }
  );
  return response;
};

export const getTopCompanyFollowees = async (
  params: ApiRequest.GetTopFollowees
) => {
  const response = await axiosInstance.get<ApiResponse.TopCompanyFollowees>(
    `/api/recruitment_planning/v1/companies/top_followees`,
    {
      params
    }
  );
  return response;
};

export const registerOnboarding = async (
  params: ApiRequest.RegisterOnboarding
) => {
  return await axiosInstance.post(
    "/api/recruitment_planning/v1/onboarding",
    params
  );
};

export const getFollowCompanies = async () => {
  const response = await axiosInstance.get<ApiResponse.FollowCompanies>(
    "/api/recruitment_planning/v1/partner_user/follows",
    {
      params: {
        types: ["company"]
      }
    }
  );
  return response;
};

export const addFollowCompanies = async (
  params: ApiRequest.AddFollowCompanies
) => {
  await axiosInstance.post<ApiResponse.FollowCompanies>(
    "/api/recruitment_planning/v1/partner_user/follows",
    {
      company_ids: params.company_ids
    }
  );
  return;
};

export const removeFollowCompanies = async (
  params: ApiRequest.RemoveFollowCompanies
) => {
  await axiosInstance.delete<ApiResponse.FollowCompanies>(
    "/api/recruitment_planning/v1/partner_user/follows",
    {
      data: {
        company_ids: params.company_ids
      }
    }
  );
  return;
};

export const getFollowsUniversities = async () => {
  const response = await axiosInstance.get<ApiResponse.FollowsUniversities>(
    "/api/recruitment_planning/v1/partner_user/follows",
    {
      params: {
        types: ["university"]
      }
    }
  );
  return response;
};

export const addFollowUniversities = async (
  params: ApiRequest.AddFollowUniversities
) => {
  await axiosInstance.post<ApiResponse.FollowsUniversities>(
    "/api/recruitment_planning/v1/partner_user/follows",
    {
      university_ids: params.university_ids
    }
  );
  return;
};

export const removeFollowUniversities = async (
  params: ApiRequest.RemoveFollowUniversities
) => {
  await axiosInstance.delete<ApiResponse.FollowCompanies>(
    "/api/recruitment_planning/v1/partner_user/follows",
    {
      data: {
        university_ids: params.university_ids
      }
    }
  );
  return;
};
